<template>
<div class="conteudoInterno">
  <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
  </div>
  <header class="headerSec">
    <h2>Arrecadação</h2>
    <div class="navSetas">
      <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
      <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
    </div> 
  </header>
  <div class="conteudoInternoBox" ref="infoBox">
    <section class="sectionRow" ref="infoscroll">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol32"></span> 
      </div> 
      <div class="col36">
        <h3>Execução pública no Brasil</h3>
        <br />
        <p class="ptreze">O Escritório Central de Arrecadação e Distribuição (ECAD), uma organização que reúne o repertório de sete associações de gestão coletiva de direitos autorais de música, entre elas a UBC, arrecadou um total de R$ 1,106 bilhão. Este montante representou uma queda de 3% com relação a 2017.</p>  
        <br />
        <p class="ptreze">O repertório da UBC representou 57% de market share com base no total distribuído pelo ECAD em 2018.</p>
        <br />
        <span class="titGraf2">Arrecadação de execução pública no Brasil (ECAD) // Obras e fonogramas em milhões (R$)</span>
        <div class="grafVideo" style="padding:84px 0 0 0;">
        <video style="width:100%;" playsinline autoplay muted>
          <source src="../assets/grafico_arrecadacao_01.mp4" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </div>
      </div><!-- col36 -->
      <div class="col36 marginColBottom">
        <h3>Arrecadação UBC</h3>
        <br />
        <p class="ptreze">A arrecadação total da UBC, que inclui os valores arrecadados através do ECAD, valores arrecadados no exterior e o montante arrecadado para o repertório representado para os direitos de reprodução, foi de R$ 616,8 milhões.</p>  
        <br />
        <span class="titGraf2">Arrecadação total da UBC em milhões (R$)</span>
        <div style="width:100%; padding:50px 0 0 0;">
          <video style="width:100%;" playsinline autoplay muted>
            <source src="../assets/grafico_arrecadacao_02.mp4" type="video/mp4"> 
            Your browser does not support HTML5 video.
          </video>
        </div>
      </div><!-- col36 -->
    </section>
    <section class="sectionRow" style="margin:60px 0 0 0;">
      <div class="col23ponto5">

      </div> 
      <div class="col36 marginColBottom">
      <h3>Arrecadação da UBC por tipo de direito</h3>
      <div style="width:100%; padding:50px 0 0 0;">
        <video style="width:100%;" playsinline autoplay muted>
          <source src="../assets/grafico_arrecadacao_03.mp4" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </div>  
      </div><!-- col36 -->
      <div class="col36">
        <h3>Arrecadação de direitos no exterior (por continente)</h3>
          <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_arrecadacao_04.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>  
      </div><!-- col36 -->  
    </section>
  </div>
</div>
</template>

<script>
export default {
  name: 'Arrecadacao',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
    }
  },
  destroyed(){  
    this.myStopFunction();
  },
  mounted () {
    this.showSetaScroll();
  },
  methods:{
    showSetaScroll: function(){
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if(alturaTela - 50 <= alturaDiv && boxABB.top == 148){
          this.setaScrollState = true
        }else{
          this.setaScrollState = false
        }
      }, 1000);
    },
    myStopFunction: function() {
      clearInterval(this.refresh);
    },
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/Arrecadacao.vue